module.exports = __webpack_public_path__ + "img/sfg_192x192.4a55c8dc.png";